import React from 'react';
import Header from '../components/Header';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const ContactPage = () => {
  return (
    <div className="App">
      <Header />
      <main><Contact /></main>
      <Footer />
    </div>
  );
};

export default ContactPage;

